<template>
  <div id="app" class="fixed-sn">
    <div class="flexible-content" >
      <main>
        <slot />
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlankLayout'
}
</script>
